import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { TableEmptyStateConfig } from './table-empty-state-config';
import { BaseButtonSizeEnum } from '../../../views/shared/components/base-button/base-button-size.enum';
import { PrimaryButtonComponent } from '../../../views/shared/components/primary-button/primary-button.component';

@Component({
  selector: 'app-table-empty-state',
  standalone: true,
  imports: [NgIf, PrimaryButtonComponent],
  templateUrl: './table-empty-state.component.html',
  styleUrls: ['./table-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableEmptyStateComponent {
  @Input() config!: TableEmptyStateConfig;
  @Input() @HostBinding('class.compact') compact: boolean = false;
  @Output() buttonClicked = new EventEmitter();
  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
